import { AWSEmailConfigurationStatus } from "models/email-domain-validation";
import { Fragment, useEffect, useState } from "react";
import { adminDoGetEmailDomainValidation } from "services/admin/email-domain-validation";
import { showSuccess } from "lib/notification";
import StatusTable from "./status-table";
import ValuePair from "components/valuepair";
import Grid from "components/grid/grid";
import Col from "components/grid/col";
import Row from "components/grid/row";
import { useOrganization } from "stores/hooks/organization";
import Info from "components/info";

const EmailConfigurationTab = () => {
  const organization = useOrganization();
  const [status, toggleStatus] = useState<
    AWSEmailConfigurationStatus | undefined
  >(undefined);
  const [loaded, toggleLoaded] = useState(false);

  const update = async () => {
    if (organization) {
      try {
        // get status
        const status = await adminDoGetEmailDomainValidation();
        toggleStatus(status);
      } catch (err) {
        // do nothing
      } finally {
        toggleLoaded(true);
      }
    }
  };

  useEffect(() => {
    update();
  }, [organization]);

  if (!organization || !loaded) {
    return null;
  }

  if (!organization.emailDomain || organization.emailDomain === null) {
    return (
      <Info>
        Organisaatiolla ei ole sähköpostiasetuksia. Ota yhteyttä
        asiakaspalveluun.
      </Info>
    );
  }

  return (
    <Fragment>
      <Grid>
        <Row>
          <Col>
            <ValuePair label="Sähköpostiosoitteen verkkotunnus">
              {organization.emailDomain}
            </ValuePair>
          </Col>
        </Row>
      </Grid>
      {status && (
        <StatusTable
          domain={organization.emailDomain}
          status={status}
          onCheck={async () => {
            update();
            showSuccess("Tietueiden tila päivitetty.");
          }}
        />
      )}
    </Fragment>
  );
};

export default EmailConfigurationTab;
